import * as lookup from "../../../static/lookup.json"
import * as moment from "moment"
import { dateFormat1 } from "../../shared/constant"
import * as journeyCodes from "../../../static/page-section-mapper.json"
import { applyComma, lineCapital } from '../../shared/functions'
export const getStateFromCode = (stateCode) => {
    console.log(stateCode)
    const options = lookup["state"][0]
    return options[stateCode]
}

export const getValueFromLookup = (lookupKey, value) => {
    if (lookupKey === "" || value === "") {
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    return lookupKey === "countryCodeToCountry" ? options?.[value] ?? "" : (options?.[value] ?? '') || "NA"
}

export const feetToCms = (feet, inches) => {
    let cms = Math.round((feet * 30.48) + (inches * 2.54))
    return parseInt(cms)
}

export const getValueFromLookup2 = (lookupKey, value) => {
    if (lookupKey === "" || value === "") {
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    return options ? options[value] : "NA"
}

export const getDateInFormat = (dateInEpoch) => {
    return moment.unix(dateInEpoch).utcOffset("+05:30").format(dateFormat1)
}

export const findRiderSA = (riderName, rider) => {
    if (!riderName || !rider || (rider.length === 0)) {
        return "NA"
    }
    let riderIndex = rider.findIndex((element) => element.name === riderName)
    if (riderIndex !== -1) {
        return applyComma(rider?.[riderIndex]?.["ca"] ?? '')
    } else {
        return "NA"
    }
}

export const generateConditonStateString = (planId) => {
    const conditionStateStringProductWise = {
        "FlexiEdgeJourney": "PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails",
        "GuarateedOnePayJourney": "PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails",
        "titaniumPlusJourney": "PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails",
        "alphaWealthPlanJourney": "AlphaWealthPlanCalculateFundValuePage.AlphaWealthPlanCFpersonelDetailsSection",
        "guaranteedSavingsOption": "PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails",
        "jeevanNivesh": "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails",
        "insureSmart": "PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails",
        "moneyBackAdvantage": "PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails",
        "guaranteedIncomeAdvantage": "PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails",
        "smartJuniorPlan": "PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails",
        "guaranteedFortuneJourney": "PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails",
        "invest4GJourney": "PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails",
        "secureBhavishyaJourney": "PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails",
        "guaranteedIncome4LifeJourney": "PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails",
        "GAINjourney": "GAINcalculatePremiumPage.GAINpersonalDetailsSection",
        "IGFPPlusJourney": "PageIGFPPlusCalculatePremium.SectionIGFPPlusPersonelDetails",
        "healthFirstJourney": "PageHealthFirstCalculateFundValue.SectionHealthFirstPersonelDetails"
    }
    return conditionStateStringProductWise[planId];
}

export const findRiderSAPercent = (riderName, rider, lookupKey, percentageName) => {
    if (!riderName || !rider || (rider.length === 0) || percentageName == '' || lookupKey == '') {
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    // return options? options[value] : "NA"
    if (!options)
        return 'NA'
    let riderIndex = rider.findIndex((element) => element.name === riderName)
    if (riderIndex !== -1) {
        return options[rider?.[riderIndex]?.[percentageName]] ?? ''
    } else {
        return "NA"
    }
}

export const getAge = (dateInEpoch) => {
    let age = Math.floor(moment(new Date()).diff(moment.unix(dateInEpoch).utcOffset("+05:30"), 'years', true))
    return age
}

export const getLastPageAndLastSection = (currentPageIndex, currentSectionIndex, totalSectionsInCurrentPage) => {
    if (currentSectionIndex + 1 < totalSectionsInCurrentPage) {
        return {
            lastPage: currentPageIndex,
            lastSection: currentSectionIndex + 1
        }
    } else {
        return {
            lastPage: currentPageIndex + 1,
            lastSection: 0
        }
    }
}

export const findCurrentJourneyCode = (pageId, sectionId) => {
    return Object.keys(journeyCodes).find(code => {
        if (journeyCodes[code].pageId === pageId && journeyCodes[code].sectionId === sectionId) {
            console.log(journeyCodes[code], code)
            return code
        }
    })

}
export const getKeyFromValueLookup = (lookupKey, value) => {
    if (lookupKey === "" || value === "") {
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    let channel = "HSBC"
    Object.keys(options).forEach(key => {
        if (options[key] === value) {
            channel = key
        }
    })
    return channel
}

export const productRenderChecker = (valuesInNvest, valueInConditionState) => {
    if (valuesInNvest.includes(",")) {
        let valueArray = valuesInNvest.split(",")
        return valueArray.some(element => element === valueInConditionState)
    } else {
        return valuesInNvest === valueInConditionState
    }
}


export const getValueFromJourney = (lookupKey, value) => {
    if (lookupKey === "" || value === "") {
        return null
    }
    //console.log(lookupKey, value, "check")
    let values = lookupKey?.[0]
    return lookupKey[0] === "countryCodeToCountry" ? values?.[value] ?? "" : (values?.[value] ?? '') || ""
}
export const getRiderInstPrem = (riders, riderName) => {
    if (riders.length === 0) {
        return 0
    }
    if (!riderName) {
        return 0
    }

    let rider = riders.find(element => element.name === riderName)
    return rider?.instPrem || 0
}

export const getRiderInstPremTotal = (riders) => {
    if (riders.length === 0) {
        return 0
    }
    let total = riders.reduce((a, b) => {
        console.log(a, b)
        return a + Number(b.instPrem)
    }, 0)
    return total?.toFixed(2)
}

export const getSourceFromChannel = (channel) => {
    if (!channel) {
        return "I"
    } else if (["A", "C"].includes(channel)) {
        return "I"
    } else {
        let MediaPartnerCodes = lookup["MediaPartnerCode"]
        let foundIndex = MediaPartnerCodes.findIndex(element => element.ITEM_CODE === channel)
        if (foundIndex !== -1) {
            return MediaPartnerCodes[foundIndex]?.SOURCE
        } else {
            return "I"
        }
    }
}

export const isEquitasChannel = channel => ["EQUITAS", "equitas", "36"].includes(channel)

/** Maps /check-payment-status (unified receipt enquiry) response to Success | Failed */
export const mapReceiptEnquiryToPaymentStatus = (enquiryRes) => {
  const receipts = enquiryRes?.data?.response
  if (!receipts || !Array.isArray(receipts) || receipts.length === 0) {
    return "Failed"
  }
  const receiptStatus = receipts[0]?.receiptStatus
  if (receiptStatus == null || String(receiptStatus).trim() === "") {
    return "Success"
  }
  const normalized = String(receiptStatus).trim().toLowerCase()
  if (normalized === "cancelled" || normalized === "failed") return "Failed"
  return "Success"
}

export const isPostRFITransaction = (transaction) =>
  transaction?.paymentType === "postRFI" ||
  transaction?.paymentMethod === "postRFI" ||
  transaction?.paymentMethod === "RFI"

/** post-rfi-receipt API: status boolean + data.status from BNCReceiptPostRFI */
export const isPostRfiReceiptSuccess = (rfiRes) =>
  rfiRes?.status === true || rfiRes?.data?.status === "Success"

export const buildPostRFIDecryptData = (rfiRes, isSuccess) => ({
  status: isSuccess ? "Success" : "Failed",
  paymentTxnDate: rfiRes?.data?.paymentTxnDate || "",
  paymentMethod: "postRFI",
  paymentTxnId: rfiRes?.data?.paymentTxnId || rfiRes?.data?.receiptNo || "",
  amount: rfiRes?.data?.amount || 0,
  errMsg: isSuccess ? "" : rfiRes?.data?.errMsg || "",
})

/** Filters makePayment sections and returns index for success / unsuccessful screen */
export const applyPostRFIPaymentOutcomeSections = (journeySteps, isSuccess) => {
  const temp = JSON.parse(JSON.stringify(journeySteps))
  const pageIndex = temp.pages?.findIndex(p => p.pageId === "makePayment")
  if (pageIndex === -1) {
    return { journeySteps: temp, targetSectionIndex: 0 }
  }

  const allSections = temp.pages[pageIndex].sections || []
  const filtered = isSuccess
    ? allSections.filter(
        s =>
          s.sectionId !== "unsuccessful-transaction" &&
          s.sectionId !== "pending-transaction" &&
          s.sectionId !== "pending-transaction-basba"
      )
    : allSections.filter(
        s =>
          s.sectionId !== "successful-transaction" &&
          s.sectionId !== "pending-transaction" &&
          s.sectionId !== "pending-transaction-basba"
      )

  temp.pages[pageIndex].sections = filtered
  const targetSectionId = isSuccess ? "successful-transaction" : "unsuccessful-transaction"
  const targetSectionIndex = filtered.findIndex(s => s.sectionId === targetSectionId)

  return {
    journeySteps: temp,
    targetSectionIndex: targetSectionIndex >= 0 ? targetSectionIndex : 0,
  }
}

export const buildPostRFISuccessTransaction = (receipt, journeyState, allJourneyData) => {
  const lastTxn = allJourneyData?.transactionDetails?.transactions?.slice(-1)[0]
  return {
    amount: receipt?.amount || journeyState.premium || "",
    applicationNumber: journeyState.applicationNo || "",
    errMsg: "",
    journeyId: journeyState.journeyId || "",
    mandate: {},
    paymentMethod: "postRFI",
    paymentType: "postRFI",
    source: receipt?.receiptCreatedBy || "ISNP",
    srcTraceId: receipt?.srcTraceId || lastTxn?.srcTraceId || allJourneyData?.transactionDetails?.srcTraceId || "",
    status: "Success",
    paymentTxnId: receipt?.receiptID || receipt?.transactionNumber || lastTxn?.paymentTxnId || "",
    paymentTxnDate: receipt?.receiptDate
      ? new Date(Number(receipt.receiptDate) * 1000).toISOString()
      : lastTxn?.paymentTxnDate || new Date().toISOString(),
    ...(receipt?.receiptID ? { receiptNo: receipt.receiptID, receiptid: receipt.receiptID } : {}),
  }
}

export const transformReceiptToTransaction = (receipt, journeyState) => {
    return {
      journeyId: journeyState.journeyId || null,
      applicationNumber: journeyState.applicationNo || null,
      status: receipt.receiptStatus || null,
      srcTraceId: receipt.srcTraceId || null,
      amount: receipt.amount || null,
      paymentTxnId: receipt.transactionNumber || null,
      source: receipt.receiptCreatedBy || null,
      paymentTxnDate: receipt.receiptDate ? new Date(Number(receipt.receiptDate) * 1000).toISOString() : null,
      paymentMethod: receipt.paymentMethod || null,
      receiptNo: receipt.receiptID || null,
      errMsg: null,
      mandateOpt: null,
      mandateTxnId: null,
      mandateTokenId: null,
      mandateId: null,
      mandate: null,
      mandateStatus: null,
      transactionNo: null,
      mercId: null,
    };
  };
